import keyAccount from "../services/key.account";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        errors: null,
        loading: false,
        modal: {
            update: {
                status: false
            }
        },
        list: [],
        keyAccountsOptions: [],
        page: 1,
        perPage: 10,
        prevPage: null,
        nextPage: null,
        maxPage: null,
        startList: null,
        endList: null,
        search: {
            keyword: null,
            filter: null,
            dateFrom: null,
            dateTo: null
        }
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setModal(state, param) {
            state.modal[param.type].status = param.status;
        },
        errors(state, errors) {
            state.error = true;
            state.errors = errors.errors;
            state.loading = false;
        },
        getList(state, response) {
            state.list = response.list;
            state.maxPage = response.max_page;
            state.nextPage = response.next_page;
            state.prevPage = response.prev_page;
            state.message = response.message;

            if (state.page == 1) {
                state.startList = 1;
            } else {
                state.startList = state.perPage * (state.page - 1) + 1;
            }

            if (state.page == state.maxPage) {
                let count = state.list.length;
                state.endList = state.perPage * (state.page - 1) + count;
            } else {
                state.endList = state.perPage * state.page;
            }
        },
        getNext(state) {
            state.page = state.nextPage;
        },
        getPrev(state) {
            state.page = state.prevPage;
        },
        getFirstPage(state) {
            state.page = 1;
        },
        setPage(state, page) {
            state.page = page;
        },
        setSearchDefault(state) {
            state.search.keyword = null;
            state.search.filter = null;
            state.search.dateFrom = null;
            state.search.dateTo = null;
        },
        setSearchFilter(state, filter) {
            state.search.keyword = filter.keyword;
            state.search.filter = filter.field == "all" ? null : filter.field;
            state.search.dateFrom = filter.dateFrom;
            state.search.dateTo = filter.dateTo;
        },
        setKeyAccountsOptions(state, keyAccountsOptions) {
            state.keyAccountsOptions = keyAccountsOptions;
        }
    },
    actions: {
        getFirstPage({ commit, dispatch }) {
            commit("getFirstPage");
            dispatch("getList");
        },
        getList: async ({ commit, state }) => {
            commit("loading", true);

            try {
                let response = await keyAccount.getList(
                    state.page,
                    state.search
                );

                commit("getList", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        getKeyAccountsOptions: async ({ commit }) => {
            commit("loading", true);

            try {
                let response = await keyAccount.getKeyAccountsOptions();

                commit("setKeyAccountsOptions", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        updateCompanyCode: async ({ commit }, param) => {
            commit("loading", true);

            try {
                let response = await keyAccount.updateCompanyCode(param);

                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        updateCompanyCodeStatus: async ({ commit }, param) => {
            commit("loading", true);

            try {
                let response = await keyAccount.updateCompanyCodeStatus(param);

                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
};
